import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="View and update your personal information, including <strong>name</strong>, <strong>email</strong>, and <strong>contact details</strong>." id="view_and_update_your_personal_informatio.8870f8c0" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Your Account" id="your_account.ab444830" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Password</strong> section to update your login credentials. You will need to enter your current password for verification." id="use_the_password_section_to_update_your.53f79728" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Changing Your Password" id="changing_your_password.820ef78a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Customize your portal experience by adjusting <strong>display</strong> and <strong>notification</strong> preferences." id="customize_your_portal_experience_by_adju.36a1b91a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Preferences" id="preferences.2bb53b2b" />
        }
    ],
    title: <FormattedMessage defaultMessage="My Account" id="my_account.e83608c1" />
};
